/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for Orders container;
 *   Integrations :  12-08-2022
 *   Version : v1.0
 *   Created :  12-09-2022
*/
/*import packages*/
import { useState, useEffect, useRef, Fragment } from 'react';
import devconfig from '../../config/config';
import { EmptyNote } from '../../components/note';
import { DataTable, FundsTab } from '../../components/dataFormating';
import { Loader } from '../../components/loader';
import APIPost from '../../services/postApi';
import { useLocation, useNavigate } from 'react-router-dom';
import SelectBox from '../../components/dropdown/selectBox';
import APIGet from '../../services/getApi';
import { PrimaryLink } from '../../components/cta';
import { Modal } from 'bootstrap';
import { DeleteOrderModal } from '../../components/modal';
import { SearchInput } from '../../components/input';

import modalStyle from '../../styles/components/confirmation.module.scss';
import styles from '../../styles/components/searchInput.module.scss';

const STATUS_OPTIONS = [
    {
        label: "Pending", value: "PENDING"
    },
    {
        label: "Order Placed", value: "ORDER_PLACED"
    },
    {
        label: "Order Failed", value: "ORDER_FAILED"
    },
    {
        label: "Order Completed", value: "ORDER_COMPLETED"
    }
]


const PendingOrders = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const initialRef = useRef(false);
    const [orderData, setOrderData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const [orderStatusOptions, setOrderStatusOptions] = useState([]);
    const [selectedOrderStatus, setSelectedOrderStatus] = useState(null);

    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [loader, setLoader] = useState(true);

    const [totalRecords, setTotalRecords] = useState(null);
    /* Total amount for the currently applied filters, across all pages.
     * Provided by the backend as `total_amount` alongside `total_records` —
     * not computed from the current page's rows. Shared across tabs like
     * `totalRecords`, and refreshed by whichever tab's list call last ran. */
    const [totalAmount, setTotalAmount] = useState(null);

    const [tabIndex, setTabindex] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const [isAmsOrder, setIsAmsOrder] = useState(false);
    const [search, setSearch] = useState("");
    const [searchResult, setSearchResult] = useState([]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [location.pathname, location.state]);

    useEffect(() => {
        if (tabIndex !== null) {
            if (tabIndex === 1) {
                _filterData();
            } else if (tabIndex === 2) {
                _basketFilterData();
            } else if (tabIndex === 3) {
                _investMoreFilterData();
            }
        }
    }, [tabIndex]);

    useEffect(() => {
        if (orderId !== null) {
            const modal = new Modal(document.getElementById("delete-order"), {});
            modal.show();
        }
    }, [orderId])

    useEffect(() => {
        setPageNum(1);
        setPerPage(10);
        if (location.state !== null) {
            setTabindex(location.state.index);
        } else {
            setTabindex(1);
        }
    }, [location.state]);

    useEffect(() => {
        if (selectedOrderStatus !== null && tabIndex !== null) {
            if (initialRef.current == false) {
                if (tabIndex === 1) {
                    getOrderList();
                } else if (tabIndex === 2) {
                    basketOrderList();
                } else if (tabIndex === 3) {
                    investMoreOrderList();
                }
                initialRef.current = true
            }
        }
        //eslint-disable-next-line
    }, [selectedOrderStatus, selectedCustomer, perPage, pageNum, tabIndex]);



    const _handleTab = (temp) => {
        if (temp !== tabIndex) {
            setLoader(true);
            navigate("/pending-orders", {
                state: {
                    index: temp
                }
            })
            setTabindex(temp);
            setPageNum(1);
            setPerPage(10);
            setSearch("");
            setSearchResult([]);
            setSelectedCustomer(null);
            initialRef.current = false
        }
    }

    const _handlePageChange = (page_num) => {
        setPageNum(page_num);
        initialRef.current = false;
    };

    const _handlePerPage = (per_page) => {
        setPerPage(per_page);
        initialRef.current = false;
    };

    const _getStatus = (status) => {
        const status_label = STATUS_OPTIONS.find((item) => item.value === status);
        if (status_label) {
            return status_label.label
        }
    }

    /*--------- order list -----------*/
    const getOrderList = (page=pageNum, size= perPage, query= selectedCustomer ? selectedCustomer.id : null) => {
        let url = devconfig.admin + '/order/reorder-list';

        let data = JSON.stringify({
            "customer_id": query,
            "status": selectedOrderStatus.value,
            page_num: page,
            page_size: size,

        });
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setOrderData(response.data.data ?? response.data);
                setTotalRecords(response.data.total_records)
                setTotalAmount(response.data.total_amount ?? null);
            } else {
                setOrderData([]);
            }
            setLoader(false);
        });
    }


    const _searchCustomer = () => {
        let url = devconfig.admin + "/general/customer-search";

        let payload = JSON.stringify({
            type: tabIndex,
            query: search

        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setSearchResult(response.data);
            } else {
                setSearchResult([]);
            }
        })
    }

    /*--------- cart pending order list -----------*/
    const basketOrderList = (page_num, page_size, query= selectedCustomer ? selectedCustomer.id : null) => {
        let url = devconfig.admin + "/basket-order/list";

        let data = JSON.stringify({
            "customer_id": query,
            "status": selectedOrderStatus.value,
            page_num: page_num ? page_num : pageNum,
            page_size: page_size ? page_size : perPage,

        });
        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setOrderData(response.data.data ?? response.data);
                setTotalRecords(response.data.total_records)
                setTotalAmount(response.data.total_amount ?? null);
            } else {
                setOrderData([]);
            }
            setLoader(false);
        });
    }

    const _getSelectedCustomerId = (override) => {
        if (override !== undefined) return override;
        if (!selectedCustomer) return null;
        return selectedCustomer.value ?? selectedCustomer.id ?? null;
    }

    /*--------- invest more order list -----------*/
    const investMoreOrderList = (page = pageNum, size = perPage, query) => {
        const url = devconfig.admin + "/order/invest-more-list";

        const data = JSON.stringify({
            customer_id: _getSelectedCustomerId(query),
            status: selectedOrderStatus?.value ?? null,
            page_num: page,
            page_size: size,
        });

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setOrderData(response.data.data ?? response.data);
                setTotalRecords(response.data.total_records);
                setTotalAmount(response.data.total_amount ?? null);
            } else {
                setOrderData([]);
                setTotalRecords(0);
                setTotalAmount(0);
            }
            setLoader(false);
        });
    }

    /*---- invest more filter api --*/
    const _investMoreFilterData = () => {
        const url = devconfig.admin + "/order/invest-more-filter";

        APIGet(url).then((response) => {
            if (response.status_code === 200 && response.data) {
                const status_options_temp = Array.isArray(response.data.status)
                    ? response.data.status.map((item) => ({
                        value: item.label === "All" ? null : item.label,
                        label: item.label === "All" ? "All" : (_getStatus(item.label) || item.label),
                    }))
                    : [{ label: "All", value: null }];

                const customers_options_temp = [
                    { label: "All", value: null },
                    ...(Array.isArray(response.data.customer_ids)
                        ? response.data.customer_ids.map((item) => ({
                            value: item.id,
                            label: item.name,
                        }))
                        : []),
                ];

                setOrderStatusOptions(status_options_temp);
                setSelectedOrderStatus(status_options_temp[0]);
                setCustomerOptions(customers_options_temp);
                setSelectedCustomer(customers_options_temp[0]);
                initialRef.current = false;
            }
        });
    }

    /*---- filter data api --*/
    const _filterData = () => {
        let status_options_temp = [];

        status_options_temp.push({
            label: "All",
            value: null
        })


        let customers_options_temp = [];

        customers_options_temp.push({
            label: "All",
            value: null
        })

        let url = devconfig.admin + '/order/re-order-filter';

        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                response.data.status.map((item) => {
                    status_options_temp.push({ value: item.label, label: item.label });
                    return true;
                });
                setOrderStatusOptions(status_options_temp);
                setSelectedOrderStatus(status_options_temp[0]);

                response.data.customer_ids.map((item) => {
                    customers_options_temp.push({ value: item.id, label: item.name });
                    return true;
                });
                setCustomerOptions(customers_options_temp);
                // setSelectedCustomer(customers_options_temp[0]);
                initialRef.current = false
            }
        });
    }

    /*---- filter data api --*/
    const _basketFilterData = () => {
        let status_options_temp = [];

        status_options_temp.push({
            label: "All",
            value: null
        })


        let customers_options_temp = [];

        customers_options_temp.push({
            label: "All",
            value: null
        })

        let url = devconfig.admin + "/basket-order/filter";

        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                response.data.status.map((item) => {
                    status_options_temp.push({ value: item.label, label: item.label });
                    return true;
                });
                setOrderStatusOptions(status_options_temp);
                setSelectedOrderStatus(status_options_temp[0]);

                response.data.customer_ids.map((item) => {
                    customers_options_temp.push({ value: item.id, label: item.name });
                    return true;
                });
                setCustomerOptions(customers_options_temp);
                setSelectedCustomer(customers_options_temp[0]);
                initialRef.current = false
            }
        });
    }

    const ORDER_COLUMNS = [

        {
            name: 'Created on',
            selector: row => row.created,
            sortable: false,
            left: true,
            minWidth: '200px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
            cell: row => <div className="col-lg-12" >
                {row.created}
            </div>
        },
        {
            name: 'Name',
            selector: row => row.customer_name,
            sortable: true,
            left: true,
            minWidth: '250px',
            cell: row => <>
                {
                    row.customer_name ?
                        <div className='e-link' onClick={() => {
                            navigate(`/user-detail?id=${row.customer_id}`, {
                                state: {
                                    tab: 2
                                }
                            })
                        }}>{row.customer_name}</div>
                        :
                        "--"
                }
            </>
        },
        {
            name: 'Amount (₹)',
            selector: row => row.amount ? parseFloat(row.amount) : 0,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: true,
            right: true,
            minWidth: '160px',
            cell: row => <div>
                {
                    row.amount ?
                        row.amount.toLocaleString('en-IN')
                        :
                        0
                }
            </div>

        },
        // {
        //     name: 'ISIN',
        //     selector: row => row.isin,
        //     // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
        //     sortable: true,
        //     left: true,
        //     minWidth: '130px',
        //     cell: row => <div>
        //         {row.isin}
        //     </div>

        // },
        // {
        //     name: 'Units',
        //     selector: row => row.units ? row.units : 0,
        //     // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
        //     sortable: true,
        //     left: true,
        //     minWidth: '130px',
        //     cell: row => <div>
        //         {row.units ? row.units : "-"}
        //     </div>

        // },
        {
            name: 'Status',
            selector: 'status',
            sortable: false,
            left: true,
            width: "200px",

            // cell: row => <div className="">
            //   <Badge type="success" text="success"/>
            // </div>

            cell: (row, key) =>
                <div className={
                    row.status === "ORDER_COMPLETED" ? `e-status-badge w-250px e-status-badge-success` :
                        row.status === "ORDER_FAILED" ? `e-status-badge w-250px e-status-badge-fail` :
                            row.status === "PENDING" ? `e-status-badge w-250px e-status-badge-pending` :
                                row.status === "ORDER_PLACED" ? `e-status-badge w-250px e-status-badge-partially` :
                                    'e-status-badge w-250px'
                }>
                    {_getStatus(row.status)}
                </div>

        },
        {
            name: 'Basket/Fund',
            selector: row => row.goal_name,
            sortable: true,
            left: true,
            minWidth: '500px',
            cell: (row) => <div className="col-lg-12">
                {row.goal_name}
            </div>
        },
        {
            name: 'Type',
            selector: row => row.order_type,
            sortable: true,
            left: true,
            width: "180px",
            cell: (row) => <div className="col-lg-12">
                {row.order_type}
            </div>
        },
        {
            name: 'MIRA ID',
            selector: (row) => row.mira_customer_id ? row.mira_customer_id : '--',
            sortable: true,
            left: true,
            width: "150px",
            defaultSortAsc: false,
        },
         {
            name: '',
            cell: row => (row.status === "PENDING" || row.status === "ORDER_FAILED") && <PrimaryLink name="Delete" className="e-delete-btn"
                handleClick={() => {
                    setOrderId(row.id);
                    setIsAmsOrder(Boolean(row.is_ams));
                }} />
        },
    ]

    const INVEST_MORE_COLUMNS = [
        {
            name: 'Created on',
            selector: row => row.created,
            sortable: false,
            left: true,
            minWidth: '200px',
            cell: row => <div className="col-lg-12">
                {row.created || "-"}
            </div>
        },
        {
            name: 'Name',
            selector: row => row.customer_name,
            sortable: true,
            left: true,
            minWidth: '250px',
            cell: row => <>
                {
                    row.customer_name ?
                        <div className='e-link' onClick={() => {
                            navigate(`/user-detail?id=${row.customer_id}`, {
                                state: {
                                    tab: 2
                                }
                            })
                        }}>{row.customer_name}</div>
                        :
                        "-"
                }
            </>
        },
        {
            name: 'Amount (₹)',
            selector: row => row.amount ? parseFloat(row.amount) : 0,
            sortable: true,
            right: true,
            minWidth: '160px',
            cell: row => <div>
                {row.amount != null && row.amount !== ""
                    ? Number(row.amount).toLocaleString('en-IN')
                    : "-"}
            </div>
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: false,
            left: true,
            width: "200px",
            cell: (row) => {
                if (!row.status) return "-";
                return (
                    <div className={
                        row.status === "ORDER_COMPLETED" ? `e-status-badge w-250px e-status-badge-success` :
                            row.status === "ORDER_FAILED" ? `e-status-badge w-250px e-status-badge-fail` :
                                row.status === "PENDING" ? `e-status-badge w-250px e-status-badge-pending` :
                                    row.status === "ORDER_PLACED" ? `e-status-badge w-250px e-status-badge-partially` :
                                        'e-status-badge w-250px'
                    }>
                        {_getStatus(row.status) || row.status}
                    </div>
                );
            }
        },
        {
            name: 'Basket/Fund/AMS',
            selector: row => row.goal_name,
            sortable: true,
            left: true,
            minWidth: '450px',
            cell: (row) => <div className="col-lg-12">
                {row.goal_name || "-"}
            </div>
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            left: true,
            width: "180px",
            cell: (row) => <div className="col-lg-12">
                {row.type || "-"}
            </div>
        },
        {
            name: 'MIRA ID',
            selector: (row) => row.mira_customer_id,
            sortable: true,
            left: true,
            width: "150px",
            defaultSortAsc: false,
            cell: (row) => <div>{row.mira_customer_id || "-"}</div>
        },
    ]

    const CART_ORDER_COLUMNS = [

        {
            name: 'Created on',
            selector: row => row.created,
            sortable: false,
            left: true,
            minWidth: '200px',
            // sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
            cell: row => <div className="col-lg-12" >
                {row.created}
            </div>
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            left: true,
            minWidth: '250px',
            cell: row => <>
                {
                    row.name ?
                        <div className='e-link' onClick={() => {
                            navigate(`/user-detail?id=${row.user_id}`, {
                                state: {
                                    tab: 2
                                }
                            })
                        }}>{row.name}</div>
                        :
                        "--"
                }
            </>
        },
        {
            name: 'Amount (₹)',
            selector: row => row.type === "SIP" ? row.sip_amount : row.lumpsum_amount,
            // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
            sortable: true,
            right: true,
            width: '140px',
            cell: row => <div>
                {
                    row.type === "SIP" ?
                        row.sip_amount && row.sip_amount.toLocaleString('en-IN')
                        :
                        row.lumpsum_amount && row.lumpsum_amount.toLocaleString('en-IN')
                }
            </div>

        },
        // {
        //     name: 'ISIN',
        //     selector: row => row.isin,
        //     // selector: (row) => row.amount ? "₹" + parseFloat(row.amount.split("₹")[1]).toFixed(2) : '--',
        //     sortable: true,
        //     left: true,
        //     minWidth: '130px',
        //     cell: row => <div>
        //         {row.isin ? row.isin : "--"}
        //     </div>

        // },
        {
            name: 'Status',
            selector: 'status',
            sortable: false,
            left: true,
            minWidth: "170px",

            // cell: row => <div className="">
            //   <Badge type="success" text="success"/>
            // </div>

            cell: (row, key) => <div className={
                row.status === "ORDER_COMPLETED" ? `e-status-badge w-250px e-status-badge-success` :
                    row.status === "ORDER_FAILED" ? `e-status-badge w-250px e-status-badge-fail` :
                        row.status === "PENDING" ? `e-status-badge w-250px e-status-badge-pending` :
                            row.status === "ORDER_PLACED" ? `e-status-badge w-250px e-status-badge-partially` :
                                'e-status-badge w-250px'
            }>
                {_getStatus(row.status)}
            </div>
        },
        {
            name: 'Basket/Fund/AMS',
            selector: row => row.goal_name,
            sortable: true,
            left: true,
            minWidth: '450px',
            cell: (row) => <div className="col-lg-12">
                {row.fund_name !== null ? row.fund_name : row.goal_name}
            </div>
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            left: true,
            width: "180px",
            cell: (row) => <div className="col-lg-12">
                {row.type}
            </div>
        },
        {
            name: 'MIRA ID',
            selector: (row) => row.customer_id ? row.customer_id : '--',
            sortable: true,
            left: true,
            width: "150px",
            defaultSortAsc: false,
        },
        {
            name: '',
            cell: row => (row.status === "PENDING" || row.status === "ORDER_FAILED") && <PrimaryLink name="Delete" className="e-delete-btn"
                handleClick={() => {
                    setOrderId(row.id);
                    setIsAmsOrder(Boolean(row.is_ams));
                }} />
        },

    ]
    return (
        <Fragment>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card e-dashboard-card border-0 py-1">
                        {
                            loader ?
                                <Loader />
                                :
                                <div className="row pt-2">
                                    <div className="col-lg-12">
                                        <FundsTab data={["Partial Orders", "Cart orders", "Invest More"]}
                                            index={tabIndex}
                                            setTab={(temp) => {
                                                _handleTab(temp)
                                            }} />
                                    </div>
                                    <div className="e-filter-wraper e-sort mt-1">
                                        <div className="row align-items-end">
                                            <div className="col-lg-2 pe-1 col-3 ">
                                                <label className="mb-1">Order status</label>
                                                <SelectBox options={orderStatusOptions}
                                                    value={selectedOrderStatus}
                                                    placeHolder="Select order status"
                                                    isSearchable={false}
                                                    selectchange={(value) => {
                                                        setSelectedOrderStatus(value);
                                                        setPageNum(1);
                                                        setPerPage(10);
                                                        initialRef.current = false;
                                                    }}
                                                />
                                            </div>

                                            {tabIndex === 3 ? (
                                                <div
                                                    className="px-1 col-3"
                                                    style={{
                                                        flex: "0 0 calc(100% / 12 * 2 * 1.1)",
                                                        maxWidth: "calc(100% / 12 * 2 * 1.1)",
                                                    }}>
                                                    <label className="mb-1">Customer</label>
                                                    <SelectBox options={customerOptions}
                                                        value={selectedCustomer}
                                                        placeHolder="Select customer"
                                                        isSearchable={true}
                                                        selectchange={(value) => {
                                                            setSelectedCustomer(value);
                                                            setPageNum(1);
                                                            setPerPage(10);
                                                            initialRef.current = false;
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                            <div className="col-lg-4 position-relative search-wrapper px-1 col-3 ">
                                                {/* <label className="mb-1">Customer</label> */}
                                                {/* <SelectBox options={customerOptions}
                                                    value={selectedCustomer}
                                                    placeHolder="Select customer"
                                                    isSearchable={false}
                                                    selectchange={(value) => {
                                                        setSelectedCustomer(value);
                                                        setPageNum(1);
                                                        setPerPage(10);
                                                        initialRef.current = false;
                                                    }}
                                                /> */}
                                                <SearchInput
                                                    placeholder="Search for customer"
                                                    value={search}
                                                    autoFocus={true}
                                                    wrapperClass="e-customer-search"
                                                    // className={modalStyle.e_search}
                                                    valueChange={(value) => {
                                                        setSearch(value);
                                                    }}
                                                    onSearch={(value) => {
                                                        _searchCustomer(value);
                                                    }}
                                                />
                                                {
                                                    search && search.length ?
                                                        <>
                                                            <span
                                                                className={`${styles.e_search_submit}`}
                                                                onClick={_searchCustomer}>
                                                            </span>
                                                            <button
                                                                className={`${styles.e_search_close} pe-3`}
                                                                onClick={() => {
                                                                    setSearch("");
                                                                    setSearchResult([]);
                                                                    setSelectedCustomer(null);
                                                                    if (tabIndex === 1) {
                                                                        getOrderList(1,10, null);
                                                                    } else if (tabIndex === 2) {
                                                                        basketOrderList(1, 10, null);
                                                                    } else {
                                                                        investMoreOrderList(1, 10, null);
                                                                    }
                                                                    
                                                                }} >
                                                            </button>
                                                        </>
                                                        :
                                                        null
                                                }
                                                {
                                                    searchResult.length ?
                                                        <div className='search-result'>
                                                            {
                                                                searchResult.map((item, key) => {
                                                                    return (
                                                                        <div className='search-value' key={key}
                                                                            onClick={() => {
                                                                                if (tabIndex === 1) {
                                                                                    getOrderList(1, 10, item.id);
                                                                                } else if (tabIndex === 2) {
                                                                                   basketOrderList(1, 10, item.id);
                                                                                } else {
                                                                                    investMoreOrderList(1, 10, item.id);
                                                                                }
                                                                                setSearch(item.name)
                                                                                setSelectedCustomer(item);
                                                                                setSearchResult([])
                                                                            }}>
                                                                            {item.name}
                                                                        </div>
                                                                    )

                                                                })
                                                            }
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                        }
                        {/*--------------- Order table -----------*/}
                        {
                            (!orderData.length) ?
                                <EmptyNote note="There are no orders to show" />
                                :
                                <div className="col-lg-12 px-0" style={{ position: "relative" }}>
                                    <DataTable
                                        pagination={true}
                                        columns={tabIndex === 1 ? ORDER_COLUMNS : tabIndex === 2 ? CART_ORDER_COLUMNS : INVEST_MORE_COLUMNS}
                                        data={orderData}
                                        perPage={perPage}
                                        paginationServer={true}
                                        selectableRows={false}
                                        paginationTotalRows={totalRecords}
                                        onChangeRowsPerPage={_handlePerPage}
                                        onChangePage={_handlePageChange}
                                        paginationDefaultPage={pageNum}
                                        selectRows={() => { }}
                                        rowClick={(row) => navigate(`/user-detail?id=${tabIndex === 2 ? row.user_id : row.customer_id}`, {
                                            state: {
                                                tab: 2
                                            }
                                        })} />
                                    {/* Total for the currently applied filters, across all pages —
                                        backend-provided via total_amount, not summed client-side. */}
                                    <div className="e-table-total" style={{ position: "absolute", left: "8px", bottom: 0, height: "56px", display: "flex", alignItems: "center", fontWeight: 600 }}>
                                        Total:&nbsp;{totalAmount == null ? '—' : '₹' + totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
            {/* confirmation modal for deleting order */}
            {
                orderId !== null && <DeleteOrderModal
                    title={`Are you sure you want to delete this order?`}
                    buttonName={"Delete Order"}
                    id={orderId}
                    isAms={isAmsOrder}
                    closeModal={() => {
                        setOrderId(null)
                        setIsAmsOrder(false)
                    }}
                    type={tabIndex}
                    updateStatus={() => {
                        setPageNum(1);
                        setPerPage(10);
                        if (tabIndex === 1) {
                            getOrderList(1, 10)
                        } else if (tabIndex === 2) {
                            basketOrderList(1, 10);
                        } else {
                            investMoreOrderList(1, 10);
                        }
                        setOrderId(null)
                        setIsAmsOrder(false)
                    }} />
            }
        </Fragment>
    )
}

export default PendingOrders